<mat-card>
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>{{ candidate.lastName }} {{ candidate.firstName }}</mat-card-title>
      <div mat-card-img class="btn-group">
        <button class="btn btn-outline-primary btn-sm" (click)="modifyCandidate()">
          <span class="material-symbols-outlined pt-1"> edit </span>
        </button>
        <button class="btn btn-outline-danger btn-sm" (click)="deleteCandidate()">
          <span class="material-symbols-outlined pt-1"> delete </span>
        </button>
      </div>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    <!-- Email -->
    <div class="row">
      <div class="col-auto title">Email :</div>
      <div class="col-auto text">{{ candidate.email }}</div>
    </div>
    <!-- Création date -->
    <div class="row">
      <div class="col-auto title">Date de création :</div>
      <div class="col-auto text">{{ candidate.createdDate | date : "dd/MM/yyyy - HH:mm" : "en-US" }}</div>
    </div>
    <!-- Group -->
    <div class="row">
      <div class="col-auto title">Groupe :</div>
      @if (groupsSummary) {
      <div class="col-auto text">
        @for (group of groupsSummary; track group; let isLast = $last) {
        <span> {{ group.name }} {{ isLast ? "" : " | " }} </span>
        }
      </div>
      } @if (!groupsSummary) {
      <div class="col-auto text">--</div>
      }
    </div>
  </mat-card-content>
</mat-card>
